import d2CrudPlus from './lib/install'
export { d2CrudPlus }
